import { Box, IconButton, makeStyles, TablePagination } from "@material-ui/core";
import { FC } from "react";
import FirstPageIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import LastPageIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

interface PropsType {
  page: number;
  rowsPerPage: number;
  totalPages: number;
  handleChangeRowsPerPage: any;
  handleChangePage: any;
}

function CustomPaginationActions(props: any) {
  const { count, page, rowsPerPage, onPageChange } = props;
  const totalPages = Math.ceil(count / rowsPerPage);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={(event) => onPageChange(event, 0)} disabled={page === 0}>
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={(event) => onPageChange(event, page - 1)} disabled={page === 0}>
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={(event) => onPageChange(event, page + 1)}
        disabled={page >= totalPages - 1}
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={(event) => onPageChange(event, totalPages - 1)}
        disabled={page >= totalPages - 1}
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

const PaginationSwitch: FC<PropsType> = ({
  page,
  rowsPerPage,
  totalPages,
  handleChangeRowsPerPage,
  handleChangePage,
}) => {
  const classes = useStyles();
  return (
    <TablePagination
      className={classes.root}
      page={page}
      rowsPerPage={rowsPerPage}
      count={totalPages}
      onRowsPerPageChange={handleChangeRowsPerPage}
      onPageChange={handleChangePage}
      rowsPerPageOptions={[10, 25, 50, 100]}
      component={"div"}
      ActionsComponent={CustomPaginationActions}
    />
  );
};

export default PaginationSwitch;

const useStyles = makeStyles((theme) => ({
  root: {

  },
  "@media (max-width: 840px)": {
    root: {
      "& .MuiTablePagination-caption:nth-child(4)": {
        display: "none",
      },
      "& .MuiTablePagination-selectRoot": {
        marginRight: 0,
      }
    }
  },
}));